<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("SIDENAV.questions.add") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #008274">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <ValidationObserver ref="observer" v-slot="{ invalid }">
        <form @submit.prevent="validateFormInputs">
          <div class="row">
            <!-- Start:: Question Body AR -->
            <ValidationProvider
              :name="$t('SIDENAV.questions.bodyAr')"
              rules="required|arabicLettersAndNumbersOnly"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="textarea"
                :placeholder="$t('SIDENAV.questions.bodyAr')"
                v-model.trim="data.nameAr"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <ValidationProvider
              :name="$t('SIDENAV.questions.bodyEn')"
              rules="required|englishLettersAndNumbersOnly"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="textarea"
                :placeholder="$t('SIDENAV.questions.bodyEn')"
                v-model.trim="data.nameEn"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- Start:: Answer AR -->
            <ValidationProvider
              :name="$t('SIDENAV.questions.answerAr')"
              rules="required|arabicLettersAndNumbersOnly"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="textarea"
                :placeholder="$t('SIDENAV.questions.answerAr')"
                v-model.trim="data.answerAr"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- Start:: Answer EN -->
            <ValidationProvider
              :name="$t('SIDENAV.questions.answerEn')"
              rules="required|englishLettersAndNumbersOnly"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="textarea"
                :placeholder="$t('SIDENAV.questions.answerEn')"
                v-model.trim="data.answerEn"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- Start:: Status -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.status')"
              rules="required"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-select-input
                col="12"
                :optionsList="activeStatuses"
                :placeholder="$t('PLACEHOLDERS.status')"
                v-model="data.is_active"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- Start:: Submit Button Wrapper -->
            <div class="btn_wrapper col-12 text-end">
              <base-button
                class="mt-2"
                styleType="primary_btn"
                :btnText="$t('BUTTONS.save')"
                :isLoading="isWaitingRequest"
                :disabled="invalid || isWaitingRequest"
              />
            </div>
            <!-- End:: Submit Button Wrapper -->
          </div>
        </form>
      </ValidationObserver>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import allowLanguageMinxin from "@/mixins/allowLanguageMinxins.js";

export default {
  name: "CreateAdditionalFields",
  mixins: [allowLanguageMinxin],

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        nameAr: null,
        nameEn: null,
        answerEn: null,
        answerAr: null,
        is_active: null,
      },
      // End:: Data Collection To Send

      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  computed: {
    activeStatuses() {
      return [
        {
          id: 1,
          name: this.$t("STATUS.active"),
          value: 1,
        },
        {
          id: 2,
          name: this.$t("STATUS.notActive"),
          value: false,
        },
      ];
    },
  },

  methods: {
    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },
    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
      this.data.answerAr = this.data.answerAr.replace(
        /[^\u0600-\u06FF\s]/g,
        ""
      );
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
      this.data.answerEn = this.data.answerEn.replace(this.EnRegex, "");
    },

    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },

    validateFormInputs() {
      this.isWaitingRequest = true;

      this.submitForm();
      return;
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      if (this.data.nameAr) {
        console.log(this.data.nameAr);

        REQUEST_DATA.append("question[ar]", this.data.nameAr);
      }
      if (this.data.nameEn) {
        console.log(this.data.nameEn);
        REQUEST_DATA.append("question[en]", this.data.nameEn);
      }
      if (this.data.answerAr) {
        REQUEST_DATA.append("answer[ar]", this.data.answerAr);
      }
      if (this.data.answerEn) {
        REQUEST_DATA.append("answer[en]", this.data.answerEn);
      }
      if (this.data.is_active) {
        REQUEST_DATA.append("is_active", this.data.is_active?.value ? 1 : 0);
      }

      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `fqas`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/questions/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  created() {
    // Start:: Fire Methods
    // this.showVehicleTypes();
    // End:: Fire Methods
  },
};
</script>

<style lang="scss" scoped>
.all_action {
  display: flex;
  gap: 15px;
}

.add_another {
  border: none;
  padding: 8px;
  width: 40px;
  height: 40px;
  border: 1px solid var(--light_gray_clr);
  border-radius: 50%;
  font-size: 18px;
  color: var(--light_gray_clr);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  .fa-trash {
    color: #ff2159;
    cursor: pointer;
  }
}
</style>
